<ng-container *ngIf="form" [formGroup]="form">
    <mat-form-field appearance="fill" class="w-full mb-2">
        <mat-label>{{ label }}</mat-label>

        <ng-container *ngIf="!isDateType; else datePickerInput">
            <input matInput [id]="id" [type]="type" [formControlName]="name" [required]="required" [readonly]="readonly" />
        </ng-container>

        <ng-template #datePickerInput>
            <div class="flex items-center w-full gap-2">
                <input
                    matInput
                    [id]="id"
                    class="flex-1 min-w-0"
                    [matDatepicker]="picker"
                    [value]="datePickerValue"
                    [required]="required"
                    [readonly]="readonly"
                    (dateChange)="onDateChange($event)" />
                <mat-datepicker-toggle [id]="id + '-toggle'" style="margin:-25px;" [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
            </div>
        </ng-template>

        <mat-error *ngIf="control?.invalid" [id]="id + '-error'">{{ errorMessage }}</mat-error>
    </mat-form-field>
</ng-container>